import { CMSResource } from "app/resources/cmsresource";

export class FooterBarLinkResource extends CMSResource {

    rid: number;

    active: boolean;

    titleRo: string;

    titleFr: string;

    titleEn: string;

    titleDe: string;

    descriptionRo: string;

    descriptionFr: string;

    descriptionEn: string;

    descriptionDe: string;

    configurable: boolean;

    openUrlBlank: boolean;

    url: string;
    userEmail:string
}